const cards = [
  {
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20visual%20with%20palace%20setting%2C%20elegant%20traditional%20clothing%2C%20warm%20cinematic%20lighting%2C%20film%20poster%20style%2C%20rich%20golden%20and%20red%20tones%2C%20dark%20atmospheric%20background&width=600&height=400&seq=cards-dsxy-01&orientation=landscape',
    tag: '古装剧场',
    title: '《大秦帝国》系列完整回顾',
    desc: '从裂变到天下，重温这部史诗级历史剧的辉煌历程',
    meta: '6部 · 全系列',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20visual%20with%20mysterious%20atmosphere%2C%20rainy%20night%20urban%20scene%2C%20noir%20cinematography%2C%20dark%20tones%20with%20red%20neon%20accents%2C%20film%20poster%20style&width=600&height=400&seq=cards-dsxy-02&orientation=landscape',
    tag: '悬疑推荐',
    title: '国产悬疑剧天花板TOP10',
    desc: '豆瓣均分8.5以上，每部都是反转不断的精品',
    meta: '10部精选',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20scene%20with%20futuristic%20city%20and%20spaceship%2C%20epic%20scale%2C%20cinematic%20lighting%2C%20dark%20space%20background%20with%20warm%20orange%20and%20blue%20highlights%2C%20film%20poster%20style&width=600&height=400&seq=cards-dsxy-03&orientation=landscape',
    tag: '科幻巨制',
    title: '中国科幻电影崛起之路',
    desc: '从《流浪地球》到《三体》，国产科幻的黄金时代来了',
    meta: '8部必看',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20performance%20with%20colorful%20lighting%2C%20music%20competition%20atmosphere%2C%20entertainment%20show%20visual%2C%20dark%20background%20with%20vibrant%20stage%20lights%2C%20cinematic%20composition&width=600&height=400&seq=cards-dsxy-04&orientation=landscape',
    tag: '综艺精选',
    title: '2026年最值得追的综艺',
    desc: '音乐、旅行、脱口秀，这份综艺片单承包你的快乐',
    meta: '12档热综',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Animated%20film%20art%20with%20Chinese%20mythological%20creatures%2C%20ink%20painting%20style%2C%20fantasy%20world%2C%20ethereal%20atmosphere%2C%20dark%20background%20with%20golden%20and%20crimson%20highlights%2C%20cinematic%20animation%20aesthetic&width=600&height=400&seq=cards-dsxy-05&orientation=landscape',
    tag: '动漫天地',
    title: '国漫崛起：不可错过的动画',
    desc: '从大银幕到小屏幕，国产动画正在创造属于它的传奇',
    meta: '15部精选',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            编辑团队精心挑选的优质内容，每一部都值得花时间
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <div
              key={card.title}
              className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer border border-background-200/60 transition-all duration-200 hover:border-background-300/60"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="inline-block bg-primary-100 text-primary-700 text-[10px] font-semibold px-2.5 py-0.5 rounded whitespace-nowrap">
                    {card.tag}
                  </span>
                  <span className="text-[11px] text-foreground-400 whitespace-nowrap">
                    {card.meta}
                  </span>
                </div>
                <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}